<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<p style="margin-top: 150px;">I would also like to express my gratitude to the following sources for providing me with the images for my book cover.</p><br/>
<p>Front cover photographs clockwise from top:</p>
<ul>
<li><p>Fagan children with their father.</p></li>
<li><p>Anne Frank—photo courtesy of Anne Frank House, Amsterdam.</p></li>
<li><p>The Evacuation of Jews—photo courtesy of Truman Library, Independence, Missouri, USA.</p></li>
<li><p>The Old Coombe Hospital, Dublin. Drawing by Michael O’Brien from Me Jewel and Darlin’ Dublin by Éamonn MacThomáis, published by The O’Brien Press Ltd. Copyright © the estate of Michael O’Brien.</p></li>
</ul>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?1ad33a9a